<script setup lang="ts">
import type { Price } from "../../composables/Api/Type/PriceSelector/packageSelector";
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import VIcon from "../Icon/VIcon.vue";
import { usePackageStore } from "./usePackageStore";
import PriceDisplay from "./VPriceDisplay.vue";

const props = defineProps<{
  price: Price
  purchasable: boolean
}>();
// this component shows either the price per year or month
// it also checkes is its purchasable and shows a icon if true

const { n, t } = useI18n();

const { isYearly } = usePackageStore();

const amount = computed(() => isYearly.value ? props.price.yearly : props.price.monthly);
// The formatted amount starts with the currency symbol, the display shows the symbol and the amount apart.
const currency = computed(() => n(amount.value, "currency").charAt(0));
const billingFrequency = computed(() => isYearly.value ? t("base.perYear") : t("base.perMonth"));
</script>

<template>
  <div v-if="purchasable">
    <PriceDisplay
      :currency="currency"
      :amount="amount"
      :billing-frequency="billingFrequency"
    />
  </div>
  <VIcon
    v-else
    class="text-[30px] text-theme-light-gray-2 dark:text-gray-500"
    name="briefcase"
    aria-hidden="true"
  />
</template>
